export const stringMapDefault = {
    placeholder: "Search"
};
